<template>
<!--  <div id="app" :style="{filter:$route.name === 'homeIndex' ? 'grayscale(100%)' : ''}">-->
  <div id="app" >
    <router-view/>
    <!-- <el-container>
       <el-header>
         <div class="TopContainer">
           <ul class="TopHeader">
              <li v-for="item in titleList" :key="item.title" @click="toUrl(item.url)">{{item.title}}</li>
           </ul>
         </div>
       </el-header>
       <el-main>

       </el-main>
     &lt;!&ndash;  <el-footer style="height: auto;position: fixed;bottom:0;width: 100%;">
         <div>@光问卷</div>
       </el-footer>&ndash;&gt;
     </el-container>-->
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        f:false,
        titleList: [
          {
            title: '我的问卷',
            url: '/'
          },
          {
            title: '问卷类型'
          }
        ],

      }
    },
    methods: {
      toUrl (url) {
        console.log(11222222)
        this.$router.push(url)
      }
    },
  /*  watch:{
      $route(newVal,oldVal){
        debugger
      }
    }*/
  }
</script>

<style>
  @import "./assets/scss/index.scss";
  body, *, html {
    padding: 0;
    margin: 0;
  }
  body,html{
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    color:#333;
    background:#f1f2f4;
  }
  .__view{
    width:-webkit-fill-available !important;
  }

  .TopContainer {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .TopHeader {
    list-style-type: none;
    overflow: hidden;
  }

  .TopHeader > a {
    font-size: 14px;
    float: left;
    padding: 0 10px;
    height: 60px;
    line-height: 60px;
    color: #707070;
  }

  .TopHeader > a:hover {
    color: #409EFF;
    cursor: pointer;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }

  /* 滚动条的滑轨背景颜色 */
  ::-webkit-scrollbar-track {
    background-color: #f1f2f4;
  }

  /* 滑块颜色 */
  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
  }

  @media screen and (max-width: 1400px) and (min-width: 700px) {

  }
  .el-rate__item .el-rate__icon{
    font-size: 30px !important;
  }
  .el-rate{
    height:30px;
  }
  .dropDownPanel .el-cascader-node.in-active-path{
    color: #4f46e5 !important;
  }
  .dropDownPanel .el-cascader-node.is-active{
    color: #4f46e5 !important;
  }
  .dropDownPanel .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color:  #4f46e5 !important;
    border-color: #4f46e5 !important;
  }
  .dropDownPanel .el-checkbox__inner:hover{
    border-color: #4f46e5 !important;
  }
  .dropDownPanel .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:  #4f46e5 !important;
    border-color: #4f46e5 !important;
  }
  .dropDownPanel .el-checkbox__input.is-focus .el-checkbox__inner{
    border-color: #4f46e5 !important;
  }
  .elDatePicker .el-date-table td.start-date span{
    background-color:  #4f46e5 !important;
  }
  .elDatePicker .el-date-table td.end-date span{
    background-color:  #4f46e5 !important;
  }
  .elDatePicker .el-date-table td.today span{
    color: #4f46e5 !important;
  }
  .elDatePicker .el-date-table td.available:hover {
    color: #4f46e5;
  }
  .elDatePicker .el-picker-panel__icon-btn:hover{
    color: #4f46e5 !important;
  }
  .dropDownCityPanel .el-select-dropdown__item.selected{
    color: #4f46e5 !important;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue